import classnames from 'classnames';
import { FC } from 'react';

import { ReactComponent as ReportsIcon } from '../../../../../shared/lib/icons/common/reports.svg';
import { ReactComponent as SearchIcon } from '../../../../../shared/lib/icons/common/search.svg';
import { ReactComponent as ArirIcon } from '../../../../../shared/lib/icons/logo/arir.svg';
import { BlockHeader } from '../../../../../shared/lib/ui';
import S from './Advantages.module.scss';
import { useTranslation } from 'react-i18next';

export const Advantages: FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  return (
    <section>
      <BlockHeader
        block={t('webmaster.advantages_section.title')}
        title={t('webmaster.advantages_section.subtitle')}
      />

      <div className={S.Blocks}>
        <div className={classnames(S.Item, S.Large)}>
          <img
            src={`/assets/img/publishers/auto-payments-${locale || 'ru'}.png`}
            alt=""
          />
          <span className={S.ItemTitle}>
            {t('webmaster.advantages_section.card_1')}
          </span>
        </div>
        <div className={S.GapWrapper}>
          {locale === 'ru' && (
            <div className={S.Item}>
              <span className={S.ItemTitle}>
                {t('webmaster.advantages_section.card_2')}
              </span>
              <ArirIcon />
            </div>
          )}
          <div className={S.Blocks}>
            <div className={classnames(S.Item, S.Small)}>
              <span className={S.ItemTitle}>
                {t('webmaster.advantages_section.card_3')}
              </span>
            </div>
            <div className={classnames(S.Item, S.Small)}>
              <span className={S.ItemTitle}>
                {t('webmaster.advantages_section.card_4')}
              </span>
            </div>
          </div>
          {locale === 'en' && (
            <div className={S.Item}>
              <span className={S.ItemTitle}>
                {t('webmaster.advantages_section.card_6')}
              </span>
              <ReportsIcon />
            </div>
          )}
        </div>
        {locale === 'ru' && (
          <div className={S.Item}>
            <span className={S.ItemTitle}>
              {t('webmaster.advantages_section.card_5')}
            </span>
            <SearchIcon />
          </div>
        )}
        {locale === 'ru' && (
          <div className={S.Item}>
            <span className={S.ItemTitle}>
              {t('webmaster.advantages_section.card_6')}
            </span>
            <ReportsIcon />
          </div>
        )}
      </div>
    </section>
  );
};
